import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

const iconByLabel = {
    Comptabilité: "bx-calculator",
    Facturation: "bx-receipt",
    Caisse: "bx-wallet",
    Finance: "bx-line-chart",
    Magasin: "bx-package",
    Carburant: "bx-gas-pump",
};

const MenuToggle = ({ label, children, icon }) => {
    const location = useLocation();
    const childItems = useMemo(() => React.Children.toArray(children), [children]);
    const hasActiveChild = childItems.some((child) => child.props.to === location.pathname);
    const [open, setOpen] = useState(hasActiveChild);
    const menuIcon = icon || iconByLabel[label] || "bx-grid-alt";

    useEffect(() => {
        if (hasActiveChild) {
            setOpen(true);
        }
    }, [hasActiveChild]);

    return (
        <li className={`menu-item ${open ? "open" : ""}`}>
            <button
                type="button"
                className="menu-link menu-toggle"
                onClick={() => setOpen((current) => !current)}
                aria-expanded={open}
            >
                <i className={`menu-icon tf-icons bx ${menuIcon}`}></i>
                <span className="menu-label">{label}</span>
                <i className="bx bx-chevron-right menu-chevron"></i>
            </button>

            <ul className="menu-sub" style={{ display: open ? "block" : "none" }}>
                {childItems}
            </ul>
        </li>
    );
};

export default MenuToggle;
